import {major,minor,build} from '../version.json';

export const GA_EVENT_NAMES = {
  PROJECT_CREATED: "create_project",
  PROJECT_DELETED: "delete_project",
  DOCUMENT_UPLOADED: "upload_document",
  ANNOTATION_CREATED: "annotation_created",
  ANNOTATION_MODIFIED: "annotation_modified",
  SHARE_INITIATED: "share_initiated",
  SEARCH_PERFORMED: "search_performed",
  COMMENT_ADDED: "comment_added",
};
export function initGA() {
  const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
  console.log("GA_ID", GA_ID);

  if (!GA_ID) {
    console.warn("No GA ID found");
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: true });
}

export function setUserProperties({
  account_type = "consumer",
  qa_automation = false,
  platform = "web",
  app_version = `${major}.${minor}.${build}`,
  os_version = navigator.userAgent,
  device_class = "desktop",
  region = navigator.language,
} = {}) {
  if (!window.gtag) return;
  window.gtag("set", "user_properties", {
    account_type,
    qa_automation,
    platform,
    app_version,
    os_version,
    device_class,
    region,
  });
}

export function logEvent(name, params = {}) {
  if (window.gtag) {
    window.gtag("event", name, params);
  }
}
